$(".btn-show-menu").click(function(e){
	e.stopPropagation();
   $(".main-menu").addClass("is-active");
});

$(".btn-close-menu").click(function(){
   $(".main-menu").removeClass("is-active");
});

$('body').click(function(){
   $(".main-menu").removeClass("is-active");
});